import Banner from "../../../../components/corporate/hiring/home/Banner";
import Ads from "../../../../components/corporate/hiring/home/Ads";
import HiringHeader from "../../../../components/common/layout/HiringHeader";

const Home = () => {
    return (
        <div className="w-full h-full min-h-screen bg-white dark:bg-bgDarkDull">
            <HiringHeader />
            <Banner />
            <Ads />
        </div>
    );
};

export default Home;